export default "/_next/static/images/explore-bg-membership-5d72a365c89a86efdc33892eeb0e4bd3.webp";